import {
  referralOwnerTypeSchema,
  referralSortSchema,
  type ReferralOwnerType,
  type ReferralSort,
} from '@manaro/contracts'

export interface ReferralFilters {
  ownerType: ReferralOwnerType
  search: string
  suspiciousOnly: boolean
  sort: ReferralSort
  page: number
}

export const DEFAULT_REFERRAL_FILTERS: ReferralFilters = {
  ownerType: 'business',
  search: '',
  suspiciousOnly: false,
  sort: 'invited',
  page: 1,
}

export function readReferralFilters(params: URLSearchParams): ReferralFilters {
  const page = Number(params.get('page'))

  return {
    ownerType: referralOwnerTypeSchema.catch(DEFAULT_REFERRAL_FILTERS.ownerType).parse(params.get('tab')),
    search: params.get('q')?.trim() ?? '',
    suspiciousOnly: params.get('suspicious') === '1',
    sort: referralSortSchema.catch(DEFAULT_REFERRAL_FILTERS.sort).parse(params.get('sort')),
    page: Number.isInteger(page) && page > 0 ? page : 1,
  }
}

export function referralFiltersToParams(filters: ReferralFilters): URLSearchParams {
  const params = new URLSearchParams()
  if (filters.ownerType !== DEFAULT_REFERRAL_FILTERS.ownerType) params.set('tab', filters.ownerType)
  if (filters.search) params.set('q', filters.search)
  if (filters.suspiciousOnly) params.set('suspicious', '1')
  if (filters.sort !== DEFAULT_REFERRAL_FILTERS.sort) params.set('sort', filters.sort)
  if (filters.page > 1) params.set('page', String(filters.page))
  return params
}

export function referralsListPath(filters: ReferralFilters): string {
  const query = referralFiltersToParams(filters).toString()
  return query ? `/referrals?${query}` : '/referrals'
}

export const referralOwnerPath = (code: string): string => `/referrals/${encodeURIComponent(code)}`
